var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogNetworkFetch = function SvgLogNetworkFetch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19340_58231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 13.3334C3.74636 13.3334 3.00016 12.5872 3.00016 11.6667V9.66669C3.00016 8.74621 2.25397 8.00002 1.3335 8.00002C2.25397 8.00002 3.00016 7.25383 3.00016 6.33335V4.33335C3.00016 3.41288 3.74636 2.66669 4.66683 2.66669",
    stroke: "#FFFB70",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 13.3334C12.2541 13.3334 13.0003 12.5872 13.0003 11.6667V9.66669C13.0003 8.74621 13.7465 8.00002 14.667 8.00002C13.7465 8.00002 13.0003 7.25383 13.0003 6.33335V4.33335C13.0003 3.41288 12.2541 2.66669 11.3337 2.66669",
    stroke: "#FFFB70",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.469 4.708H9.211V6.385H7.469V4.708ZM6.481 11.507H6.962C7.352 11.507 7.547 11.195 7.547 10.662V9.271H9.133V10.805C9.133 12.04 8.418 12.768 7.196 12.768H6.481V11.507Z",
    fill: "#FFFB70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19340_58231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogNetworkFetch as ReactComponent };
export default __webpack_public_path__ + "log-network-fetch.svg";